// Version : 0.0.1
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : EXCEL PART REMOVED
// MODFIED DATA : 27-09-2025

import ReceiptsPaymentsActionTypes from './ReceiptsPayments.types';

/** ***************** GET RECEIPTS PAYMENTS START *********************** */
export const getReceiptsPaymentsDetailsStart = (getData: any) => ({
	type: ReceiptsPaymentsActionTypes.GET_RECEIPTS_PAYMENTS_LIST_START,
	payload: getData,
});

export const getReceiptsPaymentsDetailsSuccess = (successData: any) => ({
	type: ReceiptsPaymentsActionTypes.GET_RECEIPTS_PAYMENTS_LIST_SUCCESS,
	payload: successData,
});

export const getReceiptsPaymentsDetailsFailure = (failureData: any) => ({
	type: ReceiptsPaymentsActionTypes.GET_RECEIPTS_PAYMENTS_LIST_FAILURE,
	payload: failureData,
});

export const getReceiptsPaymentsDetailsResponseResetStart = () => ({
	type: ReceiptsPaymentsActionTypes.GET_RECEIPTS_PAYMENTS_LIST_RESPONSE_RESET,
});

export const getReceiptsPaymentsDetailsResponseChanged = () => ({
	type: ReceiptsPaymentsActionTypes.GET_RECEIPTS_PAYMENTS_LIST_RESPONSE_CHANGED,
});
/** ***************** GET RECEIPTS PAYMENTS END *********************** */
